import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { of } from 'rxjs';
import { LOGIN } from '@core/constants/RoutingsPath';
import { deleteAccount, selectUser, deleteAccountFulfilled } from '../features/user.slice';
import { Store } from '@ngrx/store';
import { NotifierService } from '@core/services/notifier.service';
import { Router } from '@angular/router';
import { TokenStorageService } from '@core/services/token-storage.service';

@Injectable()
export class AccountManagerEffects {
  deleteAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteAccount),
      concatLatestFrom(() => this.store.select(selectUser)),
      switchMap(([, user]) =>
        this.userService.deleteAccount(user!.id).pipe(
          tap(() => {
            this.notifierService.openSuccessToast('manager_account.deleted');
            this.tokenStorageService.signOut();
            this.router.navigate([LOGIN]);
          }),
          map(() => deleteAccountFulfilled()),
          catchError(() => of(deleteAccountFulfilled()))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private userService: UserService,
    private store: Store,
    private notifierService: NotifierService,
    private router: Router,
    private tokenStorageService: TokenStorageService
  ) {}
}
